// src/components/NavigationMenuDrawer.js
import React from "react";
import { Drawer, Box, List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const NavigationMenuDrawer = ({ open, onClose, menuItems }) => {
  const theme = useTheme();
  const backgroundImage =
    theme.palette.mode === "dark"
      ? "url('/assets/dogwood-texture-dark.png')"
      : "url('/assets/dogwood-texture.png')";

  // Use custom header text color if defined or fallback to primary text.
  const textColor = theme.palette.header?.text || theme.palette.text.primary;

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "#AFE1AF",
          backgroundImage,
          backgroundRepeat: "repeat",
          backgroundSize: "200px",
        },
      }}
    >
      <Box sx={{ width: 250 }} role="presentation">
        <List>
          {menuItems.map((item, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton onClick={item.action}>
                <ListItemText primary={item.text} sx={{ color: textColor }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
};

export default NavigationMenuDrawer;